import React from 'react'
export default () => <div className="footer p-8" />